import React from 'react';
import { useState } from 'react';
import { Form, message } from 'antd';
import { I18n } from '@aws-amplify/core';

import { queryClient } from '@/store/query';

// import { PayloadDownloadPDF } from './types';
import { OWAS_QUERY_KEYS } from '../../../hooks/query-keys';
import { useDownloadPDF } from '../../../hooks/useDownloadPDF';
import { useConsolidateOWASReport } from '../../../hooks/useConsolidateOWASReport';
import { useOWASContext } from '../../../context';
import { SettingsModal } from './Settings';
import { Actions } from './Actions';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { useForm } = Form;

interface DownloadPDFProps {
	hiddenConsolidate?: boolean;
	isConsolidated?: boolean;
}

interface FormData {
	pdf_parameters: string[];
}

export function DownloadPDF({ isConsolidated = false }: DownloadPDFProps) {
	const [form] = useForm<FormData>();
	const { parameters, data } = useOWASContext();
	const [isOpenSettings, setIsOpenSettings] = useState<boolean>(false);

	const pdf = useDownloadPDF();
	const consolidate = useConsolidateOWASReport();

	// const {
	// 	company_id,
	// 	organization_id,
	// 	result: {
	// 		id,
	// 		consolidated,
	// 		informations: { file_id }
	// 	}
	// } = useOWASResultContext();

	const browserLanguage = window.navigator.language ?? 'en-US';

	const baseParameters = {
		organization_id: parameters?.organization_id!,
		company_id: parameters?.company_id!,
		file_id: parameters?.file_id!,
		locale: browserLanguage,
		id: data?.id!
	};

	// function onDownload(): void {
	// 	const { pdf_parameters } = form.getFieldsValue();
	// 	pdf.mutate(
	// 		{ ...config, selected_pdf_sections: pdf_parameters },
	// 		{
	// 			onSuccess: (data: string) => {
	// 				let archive = document.createElement('a');
	// 				archive.target = '_blank';
	// 				archive.href = data;
	// 				archive.click();
	// 				archive.remove();
	// 			}
	// 		}
	// 	);
	// 	handleOnCloseSettingsModal();
	// }

	// function onConsolidate(payload: PayloadDownloadPDF): void {
	// 	const alert_message = payload.status
	// 		? 'Successfully consolidated analysis'
	// 		: 'Successfully deconsolidated analysis';
	// 	consolidate.mutate(payload, {
	// 		onSuccess: () => {
	// 			message.success(I18n.get(alert_message));
	// queryClient.invalidateQueries([OWAS_QUERY_KEYS.GET_RESULT]);
	// queryClient.invalidateQueries([OWAS_QUERY_KEYS.GET_OWAS]);
	// 		}
	// 	});
	// }

	function handleOnOpenSettingsModal(): void {
		setIsOpenSettings(true);
	}

	function handleOnCloseSettingsModal(): void {
		setIsOpenSettings(false);
	}

	function getPayloadReportPDF(values: string[]) {
		return { ...baseParameters, sections: values };
	}

	function getPayloadConsolidateReport() {
		return {
			organization_id: parameters?.organization_id!,
			company_id: parameters?.company_id!,
			file_id: parameters?.file_id!,
			id: data?.id!
		};
	}

	function getGenerateFile(url: string): void {
		let archive = document.createElement('a');
		archive.target = '_blank';
		archive.href = url;
		archive.click();
		archive.remove();
	}

	async function handleOnSubmit(): Promise<void> {
		try {
			const values = await form.validateFields();
			const payload = getPayloadReportPDF(values.pdf_parameters);
			handleOnCloseSettingsModal();
			const url = await pdf.mutateAsync(payload);
			getGenerateFile(url);
		} catch (error) {
			message.open({
				content: I18n.get('Failed to generate PDF'),
				type: 'error',
				icon: <ExclamationCircleOutlined />,
				className: 'custom-toast custom-toast-error'
			});
		}
	}

	async function handleOnConsolidate(): Promise<void> {
		try {
			const payload = getPayloadConsolidateReport();
			const result = await consolidate.mutateAsync(payload);
			message.success(I18n.get(result.message));
			queryClient.invalidateQueries(['get-owas-report']);
			queryClient.invalidateQueries([OWAS_QUERY_KEYS.GET_OWAS]);
			queryClient.invalidateQueries([OWAS_QUERY_KEYS.GET_RESULT]);
		} catch (error) {
			message.open({
				content: I18n.get('Failed to consolidate PDF'),
				type: 'error',
				icon: <ExclamationCircleOutlined />,
				className: 'custom-toast custom-toast-error'
			});
		}
	}

	const initialValues = {
		pdf_parameters: ['most_dangerous_tasks', 'task_risk', 'comment']
	};

	return (
		<Form form={form} initialValues={initialValues}>
			<SettingsModal
				isDisabled={false}
				isOpen={isOpenSettings}
				isLoadingOnSubmit={false}
				onSubmit={handleOnSubmit}
				onClose={handleOnCloseSettingsModal}
			/>
			<Actions
				isConsolidated={isConsolidated}
				isLoadingDownload={pdf.isLoading}
				onConsolidate={handleOnConsolidate}
				onDownload={handleOnOpenSettingsModal}
				isLoadingConsolidate={consolidate.isLoading}
			/>
			{/* <Row justify="end">
				<Col xl={6} xxl={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						style={{
							color: '#2F54EB',
							borderRadius: '0.25rem',
							border: '1px solid #2F54EB',
							marginRight: !hiddenConsolidate ? '2rem' : '0'
						}}
						loading={pdf.isLoading}
						disabled={pdf.isLoading}
						onClick={handleOnOpenSettingsModal}
						icon={<Icons.DownloadOutlined style={{ color: '#2F54EB' }} />}
					>
						{I18n.get('Download PDF')}
					</Button>
				</Col>
				{!hiddenConsolidate && (
					<Col xl={6} xxl={4} style={{ display: 'flex', justifyContent: 'flex-end' }}>
						{!isConsolidated ? (
							<Button
								style={{
									color: '#2cc852',
									borderRadius: '0.25rem',
									border: '1px solid #2cc852'
								}}
								loading={consolidate.isLoading}
								disabled={consolidate.isLoading}
								onClick={() => onConsolidate({ ...config, status: true })}
								icon={<Icons.LockOutlined style={{ color: '#2cc852' }} />}
							>
								{I18n.get('Consolidate analysis')}
							</Button>
						) : (
							<Button
								style={{
									color: '#828282',
									borderRadius: '0.25rem',
									border: '1px solid #828282'
								}}
								loading={consolidate.isLoading}
								disabled={consolidate.isLoading}
								onClick={() => onConsolidate({ ...config, status: false })}
								icon={<Icons.UnlockOutlined style={{ color: '#828282' }} />}
							>
								{I18n.get('Deconsolidate')}
							</Button>
						)}
					</Col>
				)}
			</Row> */}
		</Form>
	);
}
